"use strict";

angular
.module("app.modals.localAdminLogin", [])

.controller("localAdminLoginModalCtrl", [
    "$scope",
    "close",
    "API",
    "$http",
    "appConfig",
    "$rootScope",
    function($scope, close, API, $http, appConfig, $rootScope) {
        function loadUserInfoForCurrentlyLoggedInUser() {
            API().User.GetCurrentUser().$promise
            .then((user) => {
                $rootScope.$emit('currentUserChanged', user);
            });
        }

        $scope.close = function(a) {
            close(a);
        };
        $scope.sendLogin = function(o) {
            $scope.loginIncorrect = false;
            $scope.loading = true;

            $http({
                url: appConfig().loginAPIURL,
                method: "POST",
                data: {
                    Password: o.adminPassword,
                    Userid: "Admin"
                },
                withCredentials: true
            }).then(response => {
                $scope.loading = false;
                if (response.data.isValid) {
                    loadUserInfoForCurrentlyLoggedInUser();
                }
                close(response.data);
                
            });

            o.adminPassword = "";
        };
    }
])

.factory("localAdminLoginModal", [
    "ModalService",
    function(ModalService) {
        return function() {
            return ModalService.showModal({
                templateUrl: "views/modals/localAdminLogin.html",
                controller: "localAdminLoginModalCtrl"
            });
        };
    }
]);
